/**
 * Reserved exchange items indicator with tooltip (copied from legacy RMA list row).
 */
import { observer } from "mobx-react";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../components/fonts/font-props";
import IconReserveItem from "../../../../../../components/icons/icon-reserve-item/icon-reserve-item";
import { Tooltip } from "../../../../../../components/tooltip/tooltip";
import { IReservedItemsInfo } from "../../../../rma-list-page/stores/rma-item-store";
import "./reserve-items-indicator.scss";

export interface IReserveItemsIndicatorProps {
    reserveItemsInfo: IReservedItemsInfo;
}

const ReserveItemsIndicator: React.FC<IReserveItemsIndicatorProps> = observer(({ reserveItemsInfo }) => {
    return (
        <div className="reserve-items-indicator">
            <Tooltip
                variant={reserveItemsInfo.tooltipVariant}
                content={
                    <div className="reserve-items-indicator__tooltip">
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>{reserveItemsInfo.tooltipText}</FontBody2>
                    </div>
                }
            >
                <IconReserveItem color={reserveItemsInfo.iconColor} />
            </Tooltip>
        </div>
    );
});

export default ReserveItemsIndicator;
